<template>
  <div class="box">
    <div class="box-header">
      <h4 class="box-title"><i class="icofont-listine-dots"></i> Resultado</h4>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <!--
                        <th>
                            Estimados
                            <span v-b-tooltip.hover title="Estimativa feita pelo Ministério da Saúde (denominador estimado)" class="icon-tooltip">
                                <i class="icofont-info-circle"></i>
                            </span>
                        </th>
                        -->
            <th>
              Numerador
              <span
                v-b-tooltip.hover
                title="Diabéticos com consulta e solicitação de hemoglobina glicada no semestre."
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Denominador
              <span
                v-b-tooltip.hover
                :title="denominadorTitle"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Município</td>
            <!--
                        <td class="text-center font-weight-bold">
                            <loader :value="no_municipio_estimadas" :loading="loading"></loader>
                        </td>
                        -->
            <td class="text-center font-weight-bold">
              <loader
                :value="
                  no_municipio_numerador > no_municipio_informadas
                    ? no_municipio_informadas
                    : no_municipio_numerador
                "
                :loading="loading"
              >
              </loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="no_municipio_informadas"
                :loading="loading"
              ></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="
                corTextoResultado(Math.round(no_municipio_resultado))
              "
            >
              <loader
                :value="no_municipio_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>Equipe</td>
            <!--
                        <td class="text-center font-weight-bold">
                            <loader :value="na_equipe_estimadas" :loading="loading"></loader>
                        </td>
                        -->
            <td class="text-center font-weight-bold">
              <loader :value="na_equipe_numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="na_equipe_informadas" :loading="loading"></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="corTextoResultado(Math.round(na_equipe_resultado))"
            >
              <loader
                :value="na_equipe_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
          <tr>
            <td>ACS</td>
            <!--
                        <td class="text-center font-weight-bold">
                            -
                        </td>
                        -->
            <td class="text-center font-weight-bold">
              <loader :value="no_acs_numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="no_acs_informadas" :loading="loading"></loader>
            </td>
            <td
              class="text-center font-weight-bold"
              v-bind:class="corTextoResultado(Math.round(no_acs_resultado))"
            >
              <loader
                :value="no_acs_resultado"
                :isPercentage="true"
                :loading="loading"
              ></loader>
            </td>
          </tr>
        </tbody>
      </table>
      <FonteEsusPecGlobal />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  components: {
    Loader,
  },
  props: {
    no_municipio_estimadas: {
      type: Number,
      default: 0,
    },
    no_municipio_informadas: {
      type: Number,
      default: 0,
    },
    no_municipio_numerador: {
      type: Number,
      default: 0,
    },
    no_municipio_resultado: {
      type: Number,
      default: 0,
    },
    no_municipio_percent_cad_sisab: {
      type: [Number, String],
      default: 0,
    },
    no_municipio_cad_sisab: {
      type: [Number, String],
      default: 0,
    },
    na_equipe_estimadas: {
      type: Number,
      default: 0,
    },
    na_equipe_informadas: {
      type: Number,
      default: 0,
    },
    na_equipe_numerador: {
      type: Number,
      default: 0,
    },
    na_equipe_resultado: {
      type: Number,
      default: 0,
    },
    no_acs_informadas: {
      type: Number,
      default: 0,
    },
    no_acs_numerador: {
      type: Number,
      default: 0,
    },
    no_acs_resultado: {
      type: Number,
      default: 0,
    },
    no_municipio_meta: {
      type: Number,
      default: 0,
    },
    na_equipe_meta: {
      type: Number,
      default: 0,
    },
    no_acs_meta: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cod_ibge: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    denominadorTitle() {
      let text = 'Diabéticos cadastrados. '
      if (
        !Number.isNaN(this.no_municipio_cad_sisab) &&
        !Number.isNaN(this.no_municipio_percent_cad_sisab)
      ) {
        text += `O percentual entre o total de cadastros no SISAB (${this.no_municipio_cad_sisab}) e a estimativa (${this.no_municipio_estimadas}) para o indicador é de ${this.no_municipio_percent_cad_sisab}%`
      }
      return text
    },
  },
  methods: {
    corTextoResultado(valor) {
      if (valor >= 50) {
        return 'blue'
      } else {
        return 'red'
      }
    },
  },
}
</script>

<style></style>
